import {
  AppShell,
  AppShellFooter,
  AppShellHeader,
} from "@generalapplications/ui";
import { RouterLinks } from "@generalapplications/ui/router";
import { Outlet, ScrollRestoration } from "react-router-dom";

import { Breadcrumbs } from "./Breadcrumbs";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

/** The page frame: the bar, the trail, the page, the footer. */
export function SiteLayout() {
  return (
    <RouterLinks>
      <AppShell>
        <AppShellHeader>
          <SiteHeader />
        </AppShellHeader>
        <AppShellFooter>
          <SiteFooter />
        </AppShellFooter>

        <Breadcrumbs />
        <Outlet />
      </AppShell>
      <ScrollRestoration />
    </RouterLinks>
  );
}
